import React from "react";

import { Text } from "recharts";

const TextWrapper = ({ y, x, children, ...rest }) => {
  return (
    <Text
      verticalAnchor="middle"
      y={y}
      x={x}
      style={{
        fontFamily: "'Roboto'",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "11px",
        lineHeight: "13px",
        letterSpacing: "1px",
        fill: "rgba(0, 27, 59, 0.94)"
      }}
      {...rest}
    >
      {children}
    </Text>
  )
};

const polarAngleAxis = ({
  payload,
  x,
  y,
  width = 672,
  height = 300,
  bottomValue = null,
  ...rest
}) => {
  const yShift = y + (y - height / 2) / 6;
  const xShift = x + (x - width / 2) / 12;

  const regex = /(?![^\n]{1,18}$)([^\n]{1,18})\s/g;
  const labelRows = payload.value.split(regex).filter(i => i !== '');
  if (bottomValue) {
    labelRows.push(`(${bottomValue})`);
  }
  const labelRowsCount = labelRows.length;
  const labelRowHeight = 12.8;
  const labelsToDisplay = labelRows.map((str, index) => {
    const newRowShift = index * labelRowHeight;
    const rowsCountTopShift = labelRowsCount > 1 ? labelRowHeight / 4 * labelRowsCount : 0;
    return <TextWrapper key={index} y={yShift + newRowShift - rowsCountTopShift} x={xShift} {...rest}>{str}</TextWrapper>;
  })
  return (
    <g>
      {labelsToDisplay}
    </g>
  );
}

export default polarAngleAxis;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/components/polar-angle-axis.js